import { PrintIcon } from '../icons';
import { Button } from '../index';
import React, { useEffect, useState, useContext } from 'react';
import ReportContext from '../../../store/Reports';
import * as LZString from 'lz-string';

const print = (report, values) => {
    const key = `/form/${report.id}`;
    const newValues = report.onlyServer ? { filters: values.filters } : values;
    localStorage.setItem(
        key,
        LZString.compress(
            JSON.stringify({
                report: report,
                data: newValues
            })
        )
    );

    window.open(key);
};

const getReports = (reports, forms, values, entities, openReport) => {
    let newReports = null;

    if (reports && reports.length !== 0) {
        newReports = {
            title: 'Formatos disponibles',
            list: reports,
            action: report => print(report, values ? values : entities),
            columns: [
                {
                    column: 'title',
                    title: 'Titulo',
                    align: 'left',
                    type: 'text'
                },
                {
                    column: 'resume',
                    title: 'Resumen',
                    align: 'left',
                    type: 'text'
                }
            ]
        };
    } else if (forms && forms.length !== 0) {
        newReports = {
            title: 'Formatos disponibles',
            list: forms.map(form => {
                return {
                    id: form.id,
                    title: form.descripcion,
                    resume: form.id + (form.edicion ? '-' + form.edicion : ''),
                    edicion: form.edicion,
                    filters: []
                };
            }),
            action: report => print(report, values ? values : entities),
            columns: [
                {
                    column: 'title',
                    title: 'Titulo',
                    align: 'left',
                    type: 'text'
                },
                {
                    column: 'resume',
                    title: 'Resumen',
                    align: 'left',
                    type: 'text'
                }
            ]
        };
    }
    return newReports;
};

const Emit = props => {
    const {
        api,
        lstForms,
        disabled,
        hidden,
        toolTipText,
        float,
        values,
        forms,
        reports,
        entities,
        Icon
    } = props;

    const { openReport } = useContext(ReportContext);
    const [selector, setSelector] = useState(null);
    const [formsSelector, setFormsSelector] = useState(null);

    useEffect(() => {
        if (api) {
            lstForms.load(api);

            return () => {
                lstForms.unload();
            };
        }
    }, [api]);

    useEffect(() => {
        if (lstForms && lstForms.isReady && selector === null) {
            let newForms = [];

            lstForms.list.forEach(form => {
                newForms.push(form.formulario);
            });

            setFormsSelector(newForms);
        }
    }, [lstForms?.isReady]);

    useEffect(() => {
        setSelector(
            getReports(reports, formsSelector, values, entities, openReport)
        );
    }, [JSON.stringify(entities)]);

    useEffect(() => {
        setSelector(
            getReports(reports, formsSelector, values, entities, openReport)
        );
    }, [JSON.stringify(values)]);

    useEffect(() => {
        if (formsSelector) {
            setSelector(
                getReports(reports, formsSelector, values, entities, openReport)
            );
        }
    }, [JSON.stringify(formsSelector)]);

    if (!selector) return null;

    return (
        <Button
            hidden={hidden}
            toolTipText={toolTipText}
            disabled={disabled}
            counter={0}
            busy={false}
            icon={!Icon ? <PrintIcon /> : <Icon />}
            selector={selector.list.length > 1 ? selector : null}
            onClick={
                selector.list.length === 1
                    ? () => selector.action(selector.list[0])
                    : undefined
            }
            float={float ? float : true}
        />
    );
};

export default Emit;
